import { LibraryTagTreeItem } from 'types';

export interface TagGroupStatus {
  ids: string[];
  checked: boolean;
  indeterminate: boolean;
}

const getDescendantIds = (item: LibraryTagTreeItem): string[] =>
  item.children.flatMap((child) => [child.id, ...getDescendantIds(child)]);

export const buildGroupStatusMap = (
  tags: LibraryTagTreeItem[],
  selectedIds: Set<string>
): Map<string, TagGroupStatus> => {
  const map = new Map<string, TagGroupStatus>();

  const processItem = (item: LibraryTagTreeItem) => {
    if (item.isGroup) {
      const ids = getDescendantIds(item);
      const selectedCount = ids.filter((id) => selectedIds.has(id)).length;
      map.set(item.id, {
        ids,
        checked: ids.length > 0 && selectedCount === ids.length,
        indeterminate: selectedCount > 0 && selectedCount < ids.length,
      });
    }

    item.children.forEach(processItem);
  };

  tags.forEach(processItem);
  return map;
};
